import { gql, useMutation } from "@outschool/ui-apollo";

// Saved mock implementation for testing - uncomment to use
// const STATIC_RESULT = {
//   data: {
//     generateAvatar: {
//       name: "Dragicorn",
//       description:
//         "This magnificent creature sports a sleek body with shimmery, tiger-striped scales, a majestic spiraling horn on its forehead, and grand, colorful wings for soaring high. It's a wise and playful friend who can gently breathe out a harmless, glittering mist that conjures instant rainbows, and its horn can make flowers bloom with a magical touch, spreading joy wherever it goes!",
//       imageUrl:
//         "https://cdn.outschool.dev/outschool-filestack-general/dragicorn_97b1dba0-69f0-4926-9784-67bcbf1936b8.png",
//     },
//   },
// };

// // Mock hook implementation - uncomment to use instead of real GraphQL call
// export function useGenerateAvatarMutation() {
//   const [loading, setLoading] = useState(false);

//   const mockGenerateAvatar = useCallback(
//     async (_options?: {
//       variables?: { animalNames: string[] };
//     }): Promise<typeof STATIC_RESULT> => {
//       setLoading(true);
//       await new Promise(resolve => setTimeout(resolve, 500));
//       setLoading(false);
//       return STATIC_RESULT;
//     },
//     [],
//   );

//   return [
//     mockGenerateAvatar,
//     {
//       loading,
//       error: undefined,
//     },
//   ] as ReturnType<typeof useMutation>;
// }

const GENERATE_AVATAR_MUTATION = gql`
  mutation GenerateAvatar($animalNames: [String!]!) {
    generateAvatar(animalNames: $animalNames) {
      name
      description
      imageUrl
    }
  }
`;

export function useGenerateAvatarMutation() {
  return useMutation(GENERATE_AVATAR_MUTATION);
}

const SAVE_AVATAR_MUTATION = gql`
  mutation SaveAvatar(
    $imageCdnUrl: String!
    $name: String!
    $description: String!
    $animals: [String!]!
  ) {
    saveAvatar(
      imageCdnUrl: $imageCdnUrl
      name: $name
      description: $description
      animals: $animals
    ) {
      uid
      learnerUid
      attachmentUid
      description
      animals
      createdAt
    }
  }
`;

export function useSaveAvatarMutation() {
  return useMutation(SAVE_AVATAR_MUTATION);
}
